import UploadIcon from '@mui/icons-material/CloudUpload'
import { Box, Button } from '@mui/material'
import type React from 'react'

interface FileInputProps {
  selectedValue: string
  label: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function FileInput({ selectedValue, label, onChange }: Readonly<FileInputProps>) {
  return (
    <Box>
      <Button
        variant="contained"
        component="label"
        color="secondary"
        size="small"
        startIcon={<UploadIcon />}
      >
        {label}
        <input hidden accept="image/*" type="file" onChange={onChange} />
      </Button>
      <Box mt={1}>
        <span>{selectedValue}</span>
      </Box>
    </Box>
  )
}

export default FileInput
